import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { TOKEN_KEY, useAuth } from '../contexts/AuthContext';

export default function SlackCompletePage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { checkAuth } = useAuth();

  useEffect(() => {
    const token = searchParams.get('t');
    if (token) {
      localStorage.setItem(TOKEN_KEY, token);
      // Re-validate the session against the backend and populate AuthContext.user
      checkAuth().finally(() => navigate('/dashboard', { replace: true }));
    } else {
      navigate('/login?slack_error=missing_token', { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-white" data-testid="slack-complete-page">
      <p className="text-sm text-[#7F8C8D]">Completing Slack sign-in…</p>
    </div>
  );
}
